import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.js$/i);
    const messages = {};

    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);

        if (matched && matched.length > 1) {
            const locale = matched[1];

            messages[locale] = locales(key);
        }
    });
    return messages;
}

const silentRegex = /^fields\./;

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'cs',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'cs',
    messages: loadLocaleMessages(),
    pluralizationRules: {
        cs: (choice, choicesLength) => {
            if (choice === 0) return 0;
            if (choice === 1) return 1;
            if (choice >= 2 && choice <= 4) return 2;
            return 3;
        },
    },

    // Allow in-app fallback for certain messages
    // Note: Returning empty string overrides default behavior of returning path
    missing: (locale, path, vm, values) => {
        if (silentRegex.test(path))
            return '';
    },
    silentTranslationWarn: silentRegex,
    silentFallbackWarn: silentRegex,
});
